import script from "./manage-build-groups-btn.vue?vue&type=script&setup=true&lang=ts"
export * from "./manage-build-groups-btn.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__